<div>
    <h3 class="title d-none d-lg-block" translate="Settings.AccountSignatureSection.Title"></h3>
    <h3 class="px-3 pt-4 pb-2 d-block d-lg-none" translate="Settings.AccountSignatureSection.Title"></h3>
</div>
<div class="pt-1 px-3 pb-4 p-lg-4 pt-lg-0 position-relative h-100">
    <app-user-signature [userGuid]="selectedUserGuid"></app-user-signature>
</div>